module.exports = __webpack_public_path__ + "static/media/intro.02819595.mp3";